// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"b97ac2fe","377":"341ecd36","417":"470c4458","467":"026efeb9","626":"e5e40771","870":"ca6c125a"}[chunkId] + ".js";
};